import { Table, Typography } from "antd";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import globalRequest from "../../../../../../utils/global/globalRequest";
import * as Apis from "../../../../../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { paginationLimit } from "../../../../../../utils/helper/constants";
import { changeLoader } from "../../../../../../redux/reducers/loader";
import { useNavigate } from "react-router-dom";
import { capitalizeName, roundToDecimal } from "../../../../../../utils/helper/utils";

const SalesByOrderType = ({ inputData, tabIndex }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const [paginationModel] = useState(paginationLimit);
  const [dataSource, setDataSource] = useState([]);

  const getAllOrderTypeReport = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(Apis.MANAGE_REPORT.GET_ALL_PAYMENTS_REPORT_ORDER_TYPE, "get", {}, { params: params }, true);
      let apiResponse = response?.data;
      if (response?.data?.status === "SUCCESS") {
        if (apiResponse?.data?.items) {
          let resultData = [];
          for (let key in apiResponse?.data?.items) {
            let item = apiResponse?.data?.items[key];
            resultData.push({
              key: key,
              orderType: item.orderType,
              totalCount: item.totalCount,
              totalAmount: roundToDecimal(item.totalAmount, 2),
            });
          }
          setDataSource(resultData);
        }
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    getAllOrderTypeReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const columns = [
    {
    title: "ID",
    dataIndex: "id",
    key: "id",
    sorter: (a, b) => a.id - b.id,
    render: (text) => text || "-"
  },
    {
      title: "Order Type",
      dataIndex: "orderType",
      key: "orderType",
      render: (text) => {
        if (!text || text === "N/A") return "-";
        return capitalizeName(text.replace(/_/g, " "));
      },
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      key: "totalAmount",
      render: (text) => (text && text !== "N/A" ? text : "-"),
    },
    {
      title: "Total Orders",
      dataIndex: "totalCount",
      key: "totalCount",
      render: (text, record) => (
        <Typography
          onClick={() => {
            navigate(`/get-order-type/${record?.orderType}`, {
              state: { inputData: inputData, tabIndex: tabIndex },
            });
          }}
          className="cursor-pointer text-[#176B53]"
        >
          {text && text !== "N/A" ? text : "-"}
        </Typography>
      ),
    },
  ];


  return (
    <>
      <Table columns={columns} dataSource={dataSource} className="multi-tables responsive" />
    </>
    );
};

export default SalesByOrderType;
